import { render, staticRenderFns } from "./TypeSection.vue?vue&type=template&id=45e4d4dc&scoped=true&"
import script from "./TypeSection.vue?vue&type=script&lang=js&"
export * from "./TypeSection.vue?vue&type=script&lang=js&"
import style0 from "./TypeSection.vue?vue&type=style&index=0&id=45e4d4dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e4d4dc",
  null
  
)

export default component.exports